/**
 * Keyboard shortcuts for AI Agent
 */
import { useEffect } from 'react';
import { useAIAgent } from '../context/AIAgentContext';

export function useKeyboardShortcuts() {
  const { toggleAgent, isVisible } = useAIAgent();
  
  useEffect(() => {
    const handleKeyPress = (event: KeyboardEvent) => {
      // Ctrl+K or Cmd+K to toggle agent
      if ((event.ctrlKey || event.metaKey) && event.key === 'k') {
        event.preventDefault();
        toggleAgent();
      }
      
      // Escape to close
      if (event.key === 'Escape' && isVisible) {
        toggleAgent();
      }
    };
    
    document.addEventListener('keydown', handleKeyPress);
    
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [toggleAgent, isVisible]);
}